import { ReactElement } from 'react';
import { Layout as MainLayout } from 'common/Layout/Layout';
import { LayoutOptions } from 'next/app';

export const Layout = (page: ReactElement, layoutOptions?: LayoutOptions) => {
  return <MainLayout layoutOptions={layoutOptions || {}}>{page}</MainLayout>;
};
